import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const testimonials = [{
  quote: "La primera vez que usé el paso 1 me sorprendí a mí misma. No grité. Solo dije 'veo que estás muy frustrado' y algo cambió en su cara. No fue magia, pero fue completamente diferente a todo lo que había intentado.",
  author: '👩 María G. — Mamá de Tomás, 4 años'
}, {
  quote: 'Lo leí en el avión de regreso. Esa misma noche mi hijo tuvo una crisis por el baño y en lugar de escalar, bajó en menos de 5 minutos. No lo podía creer.',
  author: '👨 Carlos R. — Papá de 2 niños, 3 y 6 años'
}, {
  quote: 'Lo que más me ayudó fue entender que mi hijo no me desafiaba a propósito. Eso solo ya cambió cómo me siento cuando empieza una crisis.',
  author: '👩 Valentina M. — Mamá de Sofía, 5 años'
}, {
  quote: 'El capítulo 2 me abrió los ojos. Yo era la que escalaba todo sin darme cuenta. Ahora tengo una pausa antes de hablar y eso lo cambia todo.',
  author: '👩 Andrea L. — Mamá de Lucas, 3 años'
}];
export function Testimonials() {
  return <SectionWrapper className="bg-cream-dark py-20" constrained={false} data-id="element-293">
      <div className="max-w-6xl mx-auto px-6" data-id="element-294">
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-295">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-soft border-t-4 border-t-coral flex flex-col" data-id="element-296">
              <div className="text-coral text-lg tracking-widest mb-4" data-id="element-297">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="font-sans text-lg text-ink-mid italic leading-relaxed flex-grow mb-6" data-id="element-298">
                "{t.quote}"
              </p>
              <hr className="border-hairline mb-4" data-id="element-299" />
              <p className="font-sans font-bold text-sm text-ink" data-id="element-300">{t.author}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-301">
          <p className="font-sans text-xl font-bold text-ink" data-id="element-302">
            ⭐⭐⭐⭐⭐ Más de 847 familias ya están usando el Protocolo Calma 3
            Minutos
          </p>
        </div>
      </div>
    </SectionWrapper>;
}